document.addEventListener("DOMContentLoaded", () => {
  const faq = document.querySelector(".custom__faq--accordions");
  const img = document.querySelector(".custom__faq--media img");

  function syncHeight() {
    if (window.innerWidth >= 768 && img && faq) {
      faq.style.maxHeight = img.clientHeight + "px";
    } else if (faq) {
      faq.style.maxHeight = "none";
    }
  }

  if (img) {
    img.addEventListener("load", syncHeight);
  }
  window.addEventListener("resize", syncHeight);

  syncHeight();
});
